export abstract class Constants {
    static readonly LOCALE_DEFAULT_LANG = 'en';
    static readonly LOCALE_EN = 'en-US';
    static readonly LOCALE_RO = 'ro';
    static readonly GOOGLE_MAPS_URL = 'https://www.google.com/maps/search/?api=1&query=';
    static readonly IMAGE_MIME_TYPE = 'image/png';
    static readonly LOCAL_STORAGE_CURRENT_USER_ID = 'clfl-evidence-ui-current-user-id';
    static readonly LOCAL_STORAGE_CURRENT_USER = 'clfl-evidence-ui-current-user';
    static readonly LOCAL_STORAGE_USER_LANGUAGE = 'clfl-evidence-ui-user-language';
    static readonly ACTION_EVENT_CODE = 4;
    static readonly QR_SIGNATURE_MODE = 'QR';
    static readonly DOCUMENT_STATE_CANCELED = 'Canceled';
}
